import { useMutation, useQuery, useQueryClient } from "react-query";

import {
  getCarehomesService,
  getSimplifiedCarehomesService,
  registerCarehomeService,
  updateCarehomeSubscriptionsService,
} from "./Carehomes.service";
import { Alert } from "utils";

const carehomeKeys = {
  carehomes: "carehomes",
  simplifiedCarehomes: "carehomes-simple",
};

export const useGetCarehomesQuery = (options) =>
  useQuery(carehomeKeys.carehomes,
     ({ signal }) => getCarehomesService({ signal }),
    options
  );

export const useGetSimplifiedCarehomesQuery = () =>
  useQuery(carehomeKeys.simplifiedCarehomes, getSimplifiedCarehomesService, {
    enabled: false,
  });

export const useRegisterCarehomeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((request) => registerCarehomeService(request), {
    onSuccess: () => {
      Alert.success("Carehome registered");
      queryClient.invalidateQueries(carehomeKeys.carehomes);
    },
  });
};

export const useUpdateCarehomeSubscriptionsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ userId, subscriptionId, thrivers }) =>
      updateCarehomeSubscriptionsService({
        userId,
        subscriptionId,
        thrivers,
      }),
    {
      onSuccess: () => {
        Alert.success("Carehome subscriptions updated");
        queryClient.invalidateQueries(carehomeKeys.carehomes);
        queryClient.invalidateQueries("users");
      }
    }
  );
};
